<template>
    <div class="sub_contents">
        <div class="cont_center">
            <h1 class="title_page">공지 사항</h1>

            <p class="sub_descript">
                하이비타민의 새로운 소식들을 확인하실 수 있습니다.
            </p>

            <div class="notice_view_area">
                <div class="notice_view_top">
                    <h3 class="title_notice">{{ noticeDetail.noticeTitle }}</h3>

                    <p class="notice_date"
                        style="display: flex; justify-content: flex-end; align-items: center; gap: 15px; white-space: nowrap; min-width: 0;">
                        <span style="flex-shrink: 0;"><span class="txt_label">등록일 :</span> {{ noticeDetail.regDt
                            }}</span>
                        <span style="flex-shrink: 0;"><span class="txt_hit">조회수 :</span> {{ noticeDetail.noticeCnt
                            }}</span>
                    </p>
                </div>

                <div class="notice_contents" v-html="noticeDetail.rmks">

                </div>
            </div>

            <ul class="prev_next_list">
                <li v-if="noticeDetail.prevSeq != 0">
                    <strong class="prev">이전 글</strong>

                    <p class="prev_next_txt">
                        <a href="#" @click.prevent="onPageChange(noticeDetail.prevSeq)">{{ noticeDetail.prevTitle }}</a>
                    </p>
                </li>
                <li v-if="noticeDetail.nextSeq != 0">
                    <strong class="next">다음 글</strong>

                    <p class="prev_next_txt">
                        <a href="#" @click.prevent="onPageChange(noticeDetail.nextSeq)">{{ noticeDetail.nextTitle }}</a>
                    </p>
                </li>
            </ul>

            <div class="btn_write_area">
                <RouterLink to="/HFO_CS_001" class="btn_type2">목록 보기</RouterLink>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, watch, onMounted, nextTick } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { getAxios, putAxios } from '@/lib/AxiosCall';
import { useRoute } from 'vue-router';
import { setPageMeta, setNotFoundMeta } from '@/lib/Seo';

export default {
    data() {
        return {
            noticeTitle: '[신규제휴사] 글라이더스 오픈 안내',
            noticeDate: '2024. 07. 18',
            noticeView: '2560',
            noticeContent: '안녕하세요, 하이비타민 입니다.\n해양레포츠 교육 및 체험  "글라이더스"가  제휴되어 안내드립니다.\n\n【글라이더스】\n· 혜택 : 10%청구할인 \n· 오픈일 : 2024.04.15\n\n고객 분들의 많은 이용 부탁드립니다. \n\n감사합니다.'
        }
    },
    setup() {
        const route = useRoute();
        const noticeDetail = ref({});

        const noticeReqData = ref({
            // URL 파라미터(/HFO_CS_002/:noticeSeq) 우선, 없으면 세션 값 (직접 접근·검색 유입 지원)
            noticeSeq: route.params.noticeSeq || sessionStorage.getItem('noticeSeq')
        });

        console.log('초기 요청 데이터:', noticeReqData.value);

        // 공지사항 상세 조회
        const noticeData = useQuery({
            queryKey: ['get-notice-detail', noticeReqData.value],
            queryFn: async () => {
                console.log('공지사항 상세 API 호출:', noticeReqData.value);
                const result = await getAxios("/hvm/v1/help/notice", noticeReqData.value);
                console.log('공지사항 상세 API 응답:', result);
                return result;
            },
            enabled: true, // 자동 실행 활성화
            retry: 3,
            retryDelay: 1000,
        });

        // 조회수 증가 API
        const noticeCount = useQuery({
            queryKey: ['update-notice-count', noticeReqData.value],
            queryFn: async () => {
                console.log('조회수 증가 API 호출:', noticeReqData.value);
                const result = await putAxios("/hvm/v1/help/notice", noticeReqData.value);
                console.log('조회수 증가 API 응답:', result);
                return result;
            },
            enabled: false, // 수동 실행
        });

        // 공지사항 데이터 watch
        watch(
            () => noticeData.data.value,
            (newData) => {
                console.log('공지사항 데이터 watch 트리거:', newData);

                if (newData && newData.page && newData.page.list && newData.page.list.length > 0) {
                    const notice = newData.page.list[0];
                    console.log('공지사항 상세 정보:', notice);

                    noticeDetail.value = {
                        noticeTitle: notice.noticeTitle,
                        regDt: notice.regDt,
                        rmks: notice.rmks,
                        noticeCnt: notice.noticeCnt,
                        prevSeq: notice.prev,
                        nextSeq: notice.next,
                        prevTitle: notice.prevTitle,
                        nextTitle: notice.nextTitle
                    };

                    setPageMeta({
                        title: notice.noticeTitle ? notice.noticeTitle + ' | 공지사항' : '공지사항',
                        description: notice.rmks,
                        path: '/HFO_CS_002/' + (route.params.noticeSeq || noticeReqData.value.noticeSeq || ''),
                        type: 'article',
                    });
                    console.log('noticeDetail 업데이트:', noticeDetail.value);

                    // API 호출 성공 후 조회수 증가
                    if (!window.__PRERENDER_INJECTED) noticeCount.refetch(); // 프리렌더 중 조회수 증가 방지
                } else {
                    console.warn('공지사항 데이터가 없습니다:', newData);
                    noticeDetail.value = {};
                    setNotFoundMeta("공지");
                }
            },
            { immediate: true } // 즉시 실행
        );

        // 에러 모니터링
        watch(
            () => noticeData.isError.value,
            (isError) => {
                if (isError) {
                    console.error('공지사항 데이터 로드 에러:', noticeData.error.value);
                }
            }
        );

        // 페이지 변경 함수
        function onPageChange(noticeSeq) {
            console.log('페이지 변경:', noticeSeq);
            noticeReqData.value.noticeSeq = noticeSeq;
            sessionStorage.setItem('noticeSeq', noticeSeq);
            noticeData.refetch();
        }

        return {
            noticeDetail,
            noticeReqData,
            noticeData,
            onPageChange
        }
    },
    mounted() {
        console.log('HFO_CS_002 컴포넌트 마운트됨');
        console.log('noticeSeq:', sessionStorage.getItem('noticeSeq'));
        console.log('초기 상태:', {
            isLoading: this.noticeData.isLoading.value,
            isError: this.noticeData.isError.value,
            data: this.noticeData.data.value,
            noticeDetail: this.noticeDetail
        });

        // 마운트 후 데이터가 없으면 수동으로 refetch
        nextTick(() => {
            if (!this.noticeData.data.value && !this.noticeData.isLoading.value) {
                console.log('수동 refetch 실행');
                this.noticeData.refetch();
            }
        });
    }
}
</script>